(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/views/drawselector-header.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/views/drawselector-header.js'); 
'use strict';

var DrawselectorHeader = Backbone.Marionette.View.extend({
  events: {
    click: 'toggleDrawMenu'
  },
  template: function template(data) {
    return svs.sport.drawselector.templates.drawselector_header(data);
  },
  initialize: function initialize(options) {
    this.model.set('branding', options.branding);
  },
  toggleDrawMenu: function toggleDrawMenu() {
    if (this.model.get('disableSlideDown')) {
      return;
    }

    var menuIsOpen = $('.js-caret').hasClass('icon-menu-up');

    if (menuIsOpen) {
      $('.js-caret').removeClass('icon-menu-up').addClass('icon-menu-down');
    } else {
      $('.js-caret').removeClass('icon-menu-down').addClass('icon-menu-up');
    }

    this.triggerMethod('show:menu', !menuIsOpen);
  }
});
setGlobal('svs.sport.drawselector.views.DrawselectorHeader', DrawselectorHeader);
 })(window);